import { getUrlWithQueries } from "../../utils/getUrlWithQueries"
import { api } from "./interceptor"


const filterFetch = (data, token, path) =>
	api.get(getUrlWithQueries(path, data), {
		headers: { "x-auth-token": token },
	})

const normalFetch = (token, path) =>
	api.get(path, {
		headers: { "x-auth-token": token },
	})

export { filterFetch, normalFetch }
